import { JSX } from "react";
import { QdpVerifiedResponse } from "./models/qdpVerifiedResponse";
import QdpAttestedEntity from "./QdpAttestedEntity";
import QdpEntityGroup from "./QdpEntityGroup";

interface QdpVerifiedResponses {
  QdpTruthSources: QdpVerifiedResponse[];
}

interface AccuracyEvidenceQdpTabProps {
  src: QdpVerifiedResponse;
  srcList?: QdpVerifiedResponses;
  expanding: boolean;
}

export default function AccuracyEvidenceQdpTab(evidence: AccuracyEvidenceQdpTabProps): JSX.Element {
  return (
    evidence.src ?
      <>
        <div className="card">
          <ul className="list-group list-group-flush">
            <li className="list-group-item bordered evidence-header">
              <div className="col-4">
                <b>Value</b>
              </div>
              <div className="col-4">
                <b>Value (Status)</b>
              </div>
              <div className="col-4">
                <b>Verification Reference</b>
              </div>
            </li>

            {evidence.srcList && evidence.srcList.QdpTruthSources[0].HCP ?
              <>
                <li className="list-group-item bordered" data-toggle="collapse" data-target="#hcpTopLevel">
                  <div className="col-12">
                    <span className="expandable">Practitioners</span>
                  </div>
                </li>
                <div className="collapse" id="hcpTopLevel">
                  {evidence.srcList.QdpTruthSources.map((x, i) => <div key={i}>
                    <QdpAttestedEntity entity={x.HCP} groupDepth={2} entityId={`hcp-${x.HCP.Xid}-${i}`} class="col-12 evidence-depth-1" />
                  </div>)}
                </div>
              </>
              : evidence.src.HCP && 
              <>
                <QdpAttestedEntity entity={evidence.src.HCP} groupDepth={1} entityId="Practitioner" class="col-12" />
              </>
            }

            {evidence.srcList
              ? <QdpEntityGroup entities={evidence.srcList.QdpTruthSources[0].Sls} dataId="serviceLocations" name="Service Locations" entityTag="serviceLoc" groupDepth={0} />
              : evidence.src.Sls &&
              <QdpEntityGroup entities={evidence.src.Sls} dataId="serviceLocations" name="Service Locations" entityTag="serviceLoc" groupDepth={0} />}
          </ul>
        </div>
      </>
      : !evidence.expanding
        ? <p>No corroborating data found for this provider</p>
        : <p></p>
  );
}